import { render, staticRenderFns } from "./DatosSectores.vue?vue&type=template&id=09c92bbd&scoped=true"
import script from "./DatosSectores.vue?vue&type=script&lang=js"
export * from "./DatosSectores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c92bbd",
  null
  
)

export default component.exports